<template>
  <div id="app">
    
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size:16px;
  height: 100%;
}
.row{
  display: flex;
  align-items: center;
}
.row-space{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.m-l-20{
  margin-left: 20px;
}
.m-t-5{
  margin-top: 5px;
}
.m-t-10{
  margin-top: 10px;
}
.m-t-20{
  margin-top: 20px;
}
.m-l-15{
  margin-left: 15px;
}
.m-t-35{
  margin-top: 35px;
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0; 
}

ul {
  list-style: none; }

input {
  border: 0; }
  input:focus {
    outline: none; }

.hidden {
  display: none !important; }
</style>



// WEBPACK FOOTER //
// src/App.vue